import { Component, OnInit, AfterViewInit, Input,Output,EventEmitter,ElementRef  } from '@angular/core';
import { ApiService } from "../../app/api.service";
import { CommonService } from "../../app/common.service";
import { ActivatedRoute, Router } from "@angular/router";
import { trigger, state, style, animate, transition, query, keyframes, group } from '@angular/animations';

declare var Hammer:any;
declare var $:any;

@Component({
	selector: 'component-momentview-pro',
	templateUrl: './component.momentview-pro.html',
	styleUrls: ['./component.momentview-pro.css'],
	animations:[
    //可以设置多个动画
    trigger("AnimateShow",[
      //设置从一个状态到另外一个状态的运动效果，非必填字段
      transition(":enter",animate("300ms ease-in", keyframes([
          style({transform: 'scale(0.9) translateX(-50%);', opacity: 0}),
          style({transform: 'scale(1) translateX(-50%);', opacity: 1})
        ]))),
      transition(":leave",animate("200ms ease-out", keyframes([
          style({transform: 'scale(1) translateX(-50%);', opacity: 1}),
          style({transform: 'scale(0.9) translateX(-50%);', opacity: 0})
        ]))),
    ])
    ]
})

export class componentMomentviewPro implements OnInit, AfterViewInit {

	@Output() onExit = new EventEmitter<any>();
	@Input() currentIndex: number = 0;
	@Input() momentList: any;
	@Input() theme:string;
    finished:Boolean = false;
    momentFlag:boolean = false;
    tipFlag:boolean = true;
    momentContent:string = "";
	constructor(
		private apiService: ApiService,
		private el:ElementRef
	) {}

	ngOnInit() {
		if(this.momentList.length == 1){
			this.momentList.push("no-active");
		}
		setTimeout(()=>{
			this.tipFlag = false
		},2600);
	}
	ngAfterViewInit() {
		var _this = this;
		var hammertime = new Hammer($(this.el.nativeElement).find("#momentWrap")[0]);
		hammertime.get('swipe').set({ direction: Hammer.DIRECTION_ALL });
		hammertime.on('swipeleft swiperight', function(ev){
			_this.momentEventType(ev,_this)
		});
	}
	loadConfigInfo(momentId) {
		return this.apiService.loadConfig("./assets/config/moment/"+ momentId +"-1.json");
	}

	momentEventType(ev,that){
		//向上
		if(ev.type == "swiperight"){
      if(that.currentIndex >0){
        that.currentIndex--;
        setTimeout(()=>{
          $('.next').show();
        },150);
      }
		}
		//向下
		if(ev.type == "swipeleft"){
      if(that.currentIndex < that.momentList.length -1){
        that.currentIndex++;
        setTimeout(()=>{
          $('.next').hide();
        },100);
      }
		}
	}

	viewFlag:boolean = false;
	showMoment($event) {
		$event.stopPropagation();
		if(this.viewFlag){
			return false;
		}
		this.viewFlag = true;
		setTimeout(()=>{
			this.viewFlag = false;
		},800);
		this.momentFlag = true;
		let configName = this.momentList[this.currentIndex];
		if(configName != "no-active"){
			this.loadConfigInfo(configName).subscribe((result) => {
				if(result.length > 0 && result[0].begin.length >0){
					this.momentContent = $(result[0].begin[0].el).html();
				}
			});
		}
	}

	hideMoment(){
		if(this.viewFlag){
			return false;
		}
		this.momentContent = "";
		this.viewFlag = true;
		setTimeout(()=>{
			this.viewFlag = false;
		},800);
		this.momentFlag = false;
	}

	ExitMoment(){
		this.onExit.emit();
	}
}



// WEBPACK FOOTER //
// ./src/component/momentviewpro/component.momentview-pro.ts